import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

export const ProjectTitle = styled('span')(({ theme }) => ({
  color: '#667',
  marginLeft: '8px',
  fontSize: '12px',
  position: 'absolute',
  right: '50px',
  maxWidth: '50%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    position: 'relative',
    right: 0,
    margin: 0,
    width: '100%',
    maxWidth: '100%'
  }
}));

export const SingleValueTypography = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  paddingLeft: 14,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '50%'
  }
}));
